import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent implements OnInit {

  data = {
    notes:"",followUpDate:"",type:""
  }


  constructor(public modalController: ModalController) { }

  ngOnInit() {}


  done(){
    this.modalController.dismiss({data: this.data});
  }
  back() {
    this.modalController.dismiss(null);
}
}
